import { useState } from 'react';
import { TextField, Box } from '@mui/material';

interface UrlItemFormProps {
  onDataChange: (data: { title: string; content: string }) => void;
}

export default function UrlItemForm({ onDataChange }: UrlItemFormProps) {
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');

  const handleUrlChange = (value: string) => {
    setUrl(value);
    onDataChange({ title: title, content: value });
  };

  const handleTitleChange = (value: string) => {
    setTitle(value);
    onDataChange({ title: value, content: url });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="URL"
        value={url}
        onChange={(e) => handleUrlChange(e.target.value)}
        placeholder="https://..."
        fullWidth
        required
        autoFocus
      />
      <TextField
        label="Title (optional)"
        value={title}
        onChange={(e) => handleTitleChange(e.target.value)}
        placeholder="Auto-generated from page if left empty"
        fullWidth
      />
    </Box>
  );
}
